import { render } from "./CommissionCalculator.vue?vue&type=template&id=77bf0739&scoped=true"
import script from "./CommissionCalculator.vue?vue&type=script&lang=js"
export * from "./CommissionCalculator.vue?vue&type=script&lang=js"

import "./CommissionCalculator.vue?vue&type=style&index=0&id=77bf0739&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bf0739"]])

export default __exports__